import React, { memo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Button, Center } from "@chakra-ui/react"
import { ProductVariant } from "@shopify/hydrogen-react/storefront-api-types"

type Props = {
  handleToggle: () => void
  selectedVariant: ProductVariant | null
}

export const ProductStockToggle: React.FC<Props> = memo(({ selectedVariant, handleToggle }) => {
  const { product } = useStaticQuery<GatsbyTypes.ProductStockToggleQuery>(graphql`
    query ProductStockToggle {
      product: sanityTemplateProduct {
        additionalStock
      }
    }
  `)

  return (
    <Center w="full" transform={{ base: "none", lg: "translateX(28px)" }}>
      <Button
        variant="fillWhite"
        px="25px"
        type="button"
        fontSize=" 14px"
        py={0}
        _hover={{ background: "transparent" }}
        title={product?.additionalStock || ""}
        aria-label={product?.additionalStock || ""}
        onClick={() => selectedVariant && handleToggle()}
      >
        <span className="underline-animation">{product?.additionalStock}</span>
      </Button>
    </Center>
  )
})
